class FlowNode {
  constructor(id, data) {
    this.id = id;
    this.type = data.type;
    this.options = data.options || {};
    this.gaPageViewName = data.gaPageViewName;
  }

  getType() {
    return this.type;
  }

  getOptions() {
    return this.options;
  }

  getNodeIdentifier() {
    return `${this.id}-${this.getType()}`;
  }

  getGaPageViewName() {
    return this.gaPageViewName;
  }
}

export default FlowNode;
